"use client";

import { useState } from "react";
import { InputProps } from "./input";
import { InputGroup, InputGroupAddon, InputGroupInput } from "./input-group";
import { EyeIcon } from "lucide-react";

export function PasswordInput({
  className,
  ...props
}: Omit<InputProps, "type">) {
  const [viewing, setViewing] = useState(false);

  return (
    <InputGroup className={className}>
      <InputGroupInput {...props} type={viewing ? "text" : "password"} />
      <InputGroupAddon
        onMouseDown={() => setViewing(true)}
        onMouseUp={() => setViewing(false)}
      >
        <EyeIcon />
      </InputGroupAddon>
    </InputGroup>
  );
}
